import { BEIAN } from '../beian';

type Props = { variant?: 'light' | 'dark' };

export default function Footer({ variant = 'light' }: Props) {
  const year = new Date().getFullYear();
  const text = variant === 'dark' ? 'text-white/70' : 'text-slate-400';
  const link = variant === 'dark' ? 'hover:text-white' : 'hover:text-brand-600';
  const sep = variant === 'dark' ? 'text-white/40' : 'text-slate-300';
  return (
    <footer className={`text-center text-xs py-4 px-4 select-none ${text}`}>
      <div className="mb-1">© {year} {BEIAN.company}</div>
      <div className="flex items-center justify-center gap-2 flex-wrap">
        {BEIAN.icp && (
          <a href={BEIAN.icpUrl} target="_blank" rel="noreferrer" className={`underline ${link}`}>
            {BEIAN.icp}
          </a>
        )}
        {BEIAN.police && (
          <>
            <span className={sep}>|</span>
            <a href={BEIAN.policeUrl} target="_blank" rel="noreferrer" className={`underline ${link}`}>
              {BEIAN.police}
            </a>
          </>
        )}
      </div>
    </footer>
  );
}
